
import Vue from "vue";
import moment from 'moment';
import DatePicker from "vuejs-datepicker";
import Component from "vue-class-component";
import { AxiosResponse } from 'axios';
import { Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import { TracerStudyModel } from '@/models/tracerstudy.model';
import { TracerStudy } from '@/store/tracerstudy/types';

@Component({
  components:{
    DatePicker,
  }
})
export default class ModalEditTracer extends Vue {
  /* VUEX */

  /* ACTION */
  @Action("actionEditTracerStudy", { namespace: "tracerstudy" })
  public actionEditTracerStudy: any;

  /* STATE */
  @State("school", { namespace: "academy" })
  public school: any;

  /* PROP */
  @Prop({ default: false })
  public isShow: boolean;
  @Prop({ default: false })
  public tracer: TracerStudy;

  /* INITIALIZATION */
  public form: any = new TracerStudyModel();
  public onSubmit: boolean = false;

  public get isValid(){
    let valid = true
    if(!this.form.title && valid) valid = false
    if(!this.form.description && valid) valid = false
    if(!this.form.target_start && valid) valid = false
    if(!this.form.target_end && valid) valid = false
    if(!this.form.public_start && valid) valid = false
    if(!this.form.public_end && valid) valid = false
    return valid
  }

  public get optionYearsTargetStart() : {value: number, text: string}[] {
    let year = 2000
    let options = []
    for (let i = 0; i < 30; i++) {
      let yearAdd = year + i
      options.push({
        value: yearAdd,
        text: String(yearAdd)
      })

    }
    return options
  }

  public get optionYearsTargetEnd() : {value: number, text: string}[] {
    let year = this.form.target_start
    let options = []
    for (let i = 0; i < 30; i++) {
      let yearAdd = year + i
      options.push({
        value: yearAdd,
        text: String(yearAdd)
      })

    }
    return options
  }

  public get disablePublicStart() {
    const min = new Date();
    min.setDate(min.getDate() - 1)
    return min;
  }

  public get disablePublicEnd() {
    const min = new Date();
    min.setDate(min.getDate() - 1)
    return min;
  }

  /* WATHCER */
  @Watch("isShow")
  public onChangeTracer(newVal: any){
    this.form = Object.assign({}, this.tracer);
    this.form.target_start = Number(moment(this.tracer.target_start).format("YYYY"));
    this.form.target_end = Number(moment(this.tracer.target_end).format("YYYY"));
    this.form.public_start = moment(this.tracer.public_start).format("YYYY-MM-DD");
    this.form.public_end = moment(this.tracer.public_end).format("YYYY-MM-DD");
  }

  /* METHODS */

  public dateFormat(date:any) {
    console.log(date);

    return moment(date).format("YYYY")
  }

  public onClickSubmit() {
    this.onSubmit = true;

    let params: TracerStudy = Object.assign({}, this.form);

    if (this.form.target_start instanceof Date) params.target_start = moment(this.form.target_start, "DD-MM-YYYY").format("DD-MM-YYYY")
    else params.target_start = `01-01-${this.form.target_start}`
    if (this.form.target_end instanceof Date) params.target_end = moment(this.form.target_end, "DD-MM-YYYY").format("DD-MM-YYYY")
    else params.target_end = `01-01-${this.form.target_end}`
    if (this.form.public_start instanceof Date) params.public_start = moment(this.form.public_start, "DD-MM-YYYY").format("DD-MM-YYYY")
    if (this.form.public_end instanceof Date) params.public_end = moment(this.form.public_end, "DD-MM-YYYY").format("DD-MM-YYYY")

    this.actionEditTracerStudy({
      id: this.form.id,
      params: params
    }).then((response: AxiosResponse) => {
      this.onSubmit = false;
      if (response.data.id) {
        this.$emit("update:isShow", false);
        this.$emit("onSubmited", response);
      }
    }).catch((err: AxiosResponse) => this.onSubmit = false);
  }

  toDate(date:string){
    return moment(date)
  }
}
